import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Results from "../components/Results";
import MeetLeo from "../components/MeetLeo";
import System from "../components/System";
import JobHub from "../components/JobHub";
import Pricing from "../components/Pricing";
import Guarantee from "../components/Guarantee";
import MeetAndFAQ from "../components/MeetAndFAQ";
import Footer from "../components/Footer";
import MobileStickyCTA from "../components/MobileStickyCTA";
import { useSEO } from "../lib/useSEO";

const HomePage = () => {
  useSEO({
    title: "Exterior Cleaning Marketing Australia | 7 Figure Cleaner",
    description:
      "Generate more house washing, roof washing and pressure-cleaning opportunities with done-for-you Meta ads, LEO AI follow-up and the 7FC Job Hub. One exterior cleaner per territory.",
    path: "/",
  });

  return (
    <div className="flex min-h-screen flex-col overflow-x-clip bg-white text-brand-black">
      <Header />
      <main className="flex-1">
        <Hero />
        <Results />
        <MeetLeo />
        <System />
        <JobHub />
        <Pricing />
        <Guarantee />
        <MeetAndFAQ />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
};

export default HomePage;
